(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/wager-payment-flow/fraction-flow/assets/javascripts/middlewares-setup.js') >= 0) return;  svs.modules.push('/components/wager-payment-flow/fraction-flow/assets/javascripts/middlewares-setup.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

const dialog = svs.components.dialog;
const Confirm = dialog.Confirm,
  branding = dialog.branding,
  type = dialog.type,
  message = dialog.message;
const _svs$components$payme = svs.components.payment.middleware,
  accountBalance = _svs$components$payme.accountBalance,
  paymentConfirm = _svs$components$payme.paymentConfirm,
  marketplaceMultipleShares = _svs$components$payme.marketplaceMultipleShares,
  spelpaus = _svs$components$payme.spelpaus,
  timeLimits = _svs$components$payme.timeLimits;
const _svs$components$payme2 = svs.components.payment.middleware.paymentDone,
  paymentDone = _svs$components$payme2.paymentDone,
  paymentDoneUtils = _svs$components$payme2.utils;
const spelpausMw = spelpaus(interactionContext => new Promise((resolve, reject) => {
  const defaultAction = [{
    title: 'Stäng',
    callback: () => {},
    showLoader: true
  }];
  const _interactionContext$d = interactionContext.data.exclusion,
    text = _interactionContext$d.text,
    title = _interactionContext$d.title,
    icon = _interactionContext$d.icon,
    _interactionContext$d2 = _interactionContext$d.actions,
    actions = _interactionContext$d2 === void 0 ? defaultAction : _interactionContext$d2;
  dialog.api.add(new Confirm({
    branding: svs.components.dialog.branding.SPORT,
    type: svs.components.dialog.type.DEFAULT,
    icon,
    title,
    message: [{
      type: svs.components.dialog.message.TEXT,
      text
    }],
    actions: actions.map(action => [_objectSpread(_objectSpread({}, action), {}, {
      callback: () => {
        !action.shouldNotClose && svs.components.dialog.api.close();
        !action.shouldNotReject && reject();
        action.callback();
      }
    })][0])
  }));
}));
const timeLimitsMw = timeLimits(interactionContext => new Promise((resolve, reject) => {
  const messages = interactionContext.messages,
    title = interactionContext.title;
  dialog.api.add(new Confirm({
    branding: branding.SPORT,
    type: type.DEFAULT,
    icon: 'time-limit',
    title,
    message: [{
      type: message.TEXT,
      text: [messages[0], messages[1]].join('<br />')
    }],
    actions: [{
      title: 'Stäng',
      showLoader: true,
      callback() {
        dialog.api.close();
        reject(new Error('Time limit exceeded'));
      }
    }, {
      title: 'Till mina gränser',
      showLoader: true,
      callback() {
        dialog.api.close();
        resolve();
      }
    }]
  }));
}));

const accountBalanceMw = accountBalance(interactionContext => new Promise((resolve, reject) => {
  const messages = interactionContext.messages,
    title = interactionContext.title;
  dialog.api.add(new Confirm({
    branding: branding.SPORT,
    type: type.DEFAULT,
    icon: 'balance',
    title,
    message: [{
      type: message.TEXT,
      text: [messages[0], messages[1]].join('<br />')
    }],
    actions: [{
      title: 'Avbryt',
      showLoader: true,
      callback() {
        dialog.api.close();
        reject();
      }
    }, {
      title: 'Sätt in',
      showLoader: true,
      callback() {
        dialog.api.close();
        resolve();
      }
    }]
  }));
}));
const paymentConfirmMw = paymentConfirm(paymentContext => new Promise((resolve, reject) => {
  const title = paymentContext.title,
    customMessage = paymentContext.customMessage;
  const dialogConfig = {
    branding: branding.SPORT,
    type: type.DEFAULT,
    icon: 'nav-games',
    title,
    actions: [{
      title: 'Avbryt',
      showLoader: true,
      callback() {
        dialog.api.close();
        reject();
      }
    }, {
      title: 'Betala',
      showLoader: true,
      callback() {
        dialog.api.close();
        resolve();
      }
    }]
  };
  if (customMessage) {
    dialogConfig.message = [{
      type: message.TEXT,
      text: customMessage
    }];
  }
  dialog.api.add(new Confirm(dialogConfig));
}));
const paymentDoneSuccess = paymentDoneContext => new Promise(resolve => {
  const title = paymentDoneContext.title,
    dialogMessage = paymentDoneContext.message,
    onCallback = paymentDoneContext.onCallback;
  dialog.api.add(new Confirm({
    branding: branding.SPORT,
    type: type.DEFAULT,
    icon: 'thumbs-up',
    title,
    message: [{
      type: message.TEXT,
      text: dialogMessage
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        onCallback(paymentDoneUtils.TRACKING_ACTIONS.OK);
        dialog.api.close();
        resolve();
      },
      showLoader: true
    }]
  }));
});
const marketplaceMultipleSharesMW = marketplaceMultipleShares(marketplaceMultipleSharesContext => new Promise((resolve, reject) => {
  const messages = marketplaceMultipleSharesContext.messages,
    title = marketplaceMultipleSharesContext.title;
  dialog.api.add(new Confirm({
    branding: branding.SPORT,
    type: type.DEFAULT,
    icon: 'andelsspel',
    title,
    message: [{
      type: message.TEXT,
      text: [messages[0], messages[1]].join('<br />')
    }],
    actions: [{
      title: messages[2],
      showLoader: true,
      callback() {
        dialog.api.close();
        reject();
      }
    }, {
      title: messages[3],
      showLoader: true,
      callback() {
        dialog.api.close();
        resolve();
      }
    }]
  }));
}));
const paymentDoneFailure = paymentDoneContext => {
  const clientErrors = paymentDoneContext.clientErrors,
    clientCode = paymentDoneContext.clientCode;
  svs.components.wagerPaymentFlow.paymentFailure.paymentFailureDialog(clientErrors, clientCode);
};
const paymentDoneMw = paymentDone(paymentDoneSuccess, paymentDoneFailure);
setGlobal('svs.components.wagerPaymentFlow.fractionFlow.middlewareSetup', {
  accountBalanceMw,
  paymentConfirmMw,
  paymentDoneMw,
  spelpausMw,
  timeLimitsMw,
  marketplaceMultipleSharesMW
});

 })(window);